import { render, staticRenderFns } from "./StampaEtichetta.vue?vue&type=template&id=29a491c1&"
import script from "./StampaEtichetta.vue?vue&type=script&lang=js&"
export * from "./StampaEtichetta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports